// import { Autoplay, Navigation } from 'swiper';
// import { swiperOnResize } from '../utils/swiperOnResize.utils.js';

// let gallerySwiperWr = document.querySelectorAll('.galley-swiper-wr');
// gallerySwiperWr.forEach((el) => {
//   if (el) {
//     let swiperEl = el.querySelector('.swiper');
//     let nextEl = el.querySelector('.swiper-button-next');
//     let prevEl = el.querySelector('.swiper-button-prev');
//     let slidesCount = el.querySelectorAll('.swiper-slide').length;
//     let wrapper = swiperEl.querySelector('.swiper-wrapper');

//     swiperOnResize('(max-width: 1023px)', swiperEl, {
//       modules: [Autoplay, Navigation],
//       slidesPerView: 'auto',
//       spaceBetween: 12,
//       autoplay: {
//         delay: 4000,
//         disableOnInteraction: false,
//         pauseOnMouseEnter: true,
//       },
//       breakpoints: {

//       },
//     });
//   }
// });
